import * as React from 'react'
import { Updater, IOWidget, fromJSX } from 'widgets-for-react'
import { CMSState, Url } from '../types.gen'

export type DownloadBlockProps = {
  index: number
  title?: string
  intro?: string
  items: DownloadProps[]
}

export type DownloadProps = {
  key?: string
  title: string
  text?: string
  file_url: Url
}

// Rendered in archivedDownloadsBlock

export function DownloadBlock(
  props: DownloadBlockProps
): IOWidget<CMSState, Updater<CMSState>> {
  if (!props.items || props.items.length == 0) return null
  return (s: CMSState) =>
    fromJSX(() => (
        <></>
      )
    )
}
